import type { ReactNode } from "react";
import { useEffect } from "react";
import { ListItem, ListItemText } from "@mui/material";
import ControlledTextField from "components/inputs/ControlledTextField";
import { useFieldArray, useWatch } from "react-hook-form";
import { emailRules } from "constants/InputRules";

const MAX_INPUTS_NUMBER = 4;
const NAME = "emailsComplementaires";

function EmailsComplementairesListItems(): ReactNode {
  const { fields, append, replace } = useFieldArray({ name: NAME });
  const emailsComplementaires: Array<string> = useWatch({ name: NAME });

  useEffect(() => {
    if (emailsComplementaires == null) {
      replace([]);
    } else {
      // Trouver et supprimer les inputs vides qui ne sont pas le dernier
      const indexToRemove = emailsComplementaires.indexOf("");
      if (indexToRemove !== -1 && indexToRemove !== emailsComplementaires.length - 1) {
        const newEmailsComplementaires = [...emailsComplementaires];
        newEmailsComplementaires.splice(indexToRemove, 1);
        replace(newEmailsComplementaires);
      }

      // Ajouter un input vide à la fin
      if (emailsComplementaires.at(-1) !== "" && emailsComplementaires.length < MAX_INPUTS_NUMBER) {
        append("");
      }
    }
  }, [emailsComplementaires, replace, append]);

  return fields?.map((field, index) => (
    <ListItem key={field.id}>
      <ListItemText>
        <ControlledTextField
          name={`emailsComplementaires.${index}`}
          label={`E-mail complémentaire ${index + 1}`}
          rules={emailRules}
        />
      </ListItemText>
    </ListItem>
  ));
}

export default EmailsComplementairesListItems;
